import { Utilities } from "@tylertech/shared-module";
import { Expression } from "./abstract.expression";
export class OrderByFunction extends Expression
{
    private orderByField: string;

    private thenByField: string;

    constructor(field: string, value?: string)
    {
        super();
        this.orderByField = field;
        this.thenByField = value;
    }

    toQuery(): string
    {
        if (!Utilities.IsNullOrUndefined(this.thenByField))
        {
            return "$orderBy=" + this.orderByField + "&$thenBy=" + this.thenByField;
        }
        return "$orderBy=" + this.orderByField;
    }
}
